import React from 'react'
import { connect } from 'dva'
import { bindActionCreators } from 'redux'

import questionSelector from 'models/question/selectors'
import * as questionActions from 'models/question/actions'

import Result from './Result'

const preloaderTime = 1600

class ResultContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isPreloaderDisplayed: true,
    }
  }

  componentDidMount = () => {
    setTimeout(() => {
      this.setState({
        isPreloaderDisplayed: false
      })
    }, preloaderTime)
  }

  goToNext = () => {
    this.props.hideQuestion()

    setTimeout(() => {
      this.props.goToNextQuestion()
    }, 300)
  }

  render() {
    const { currentResult, goToNextQuestion } = this.props
    const { isPreloaderDisplayed } = this.state

    return (
      <Result
        isPreloaderDisplayed={isPreloaderDisplayed}
        currentResult={currentResult}
        goToNextQuestion={this.goToNext}
      />
    )
  }
}

function mapStateToProps(state, ownProps) {
  return Object.assign({},
    questionSelector(state, ownProps),
  )
}

function mapDispatchToProps(dispatch) {
  const questionBoundActions = bindActionCreators(questionActions, dispatch)

  return {
    goToNextQuestion: questionBoundActions.goToNext,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResultContainer)



// WEBPACK FOOTER //
// ./src/components/Question/components/Result/index.js